interface LoadingSpinnerProps {
  label: string;
  testId?: string;
}

export function LoadingSpinner({ label, testId }: LoadingSpinnerProps) {
  return (
    <div
      className="flex justify-center items-center py-12"
      role="status"
      aria-label={label}
      data-testid={testId}
    >
      <div className="animate-spin rounded-full h-8 w-8 border-2 border-wolisho-red border-t-transparent" />
    </div>
  );
}
